import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { BUSCAR_RESERVA } from '../types';

export default function buscarReserva (idReserva, idEmpresa) {
  const url = `${URL}/reserva/${idReserva}/empresa/${idEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_RESERVA,
        payload: response

      })
  );
}
